import { createSelector } from 'reselect';

const routerSelector = state => state.router;

export const getCurrentPathname = createSelector(
  routerSelector,
  router => router.location.pathname,
);



// WEBPACK FOOTER //
// ./src/core/router/selectors.js